import { __assign } from "tslib";
import React from 'react';
import InternalIcon from '../../icon/internal';
import styles from './styles.css.js';
var ItemIcon = function (props) {
    return (React.createElement("span", { className: styles.icon },
        React.createElement(InternalIcon, __assign({}, props))));
};
export default ItemIcon;
//# sourceMappingURL=item-icon.js.map